import {RegionPublicIpPrefixResource} from "client/resources/regionPublicIpPrefixResource";

export type RegionPublicIpPrefixChange = "Publish" | "Unpublish" | "MakeAvailable" | "MakeUnavailable";

// A prefix must be published before it's available, and unavailable before it's unpublished
export function getAllowedChanges(prefix: RegionPublicIpPrefixResource): RegionPublicIpPrefixChange[] {
    if (prefix.IsAvailable) {
        return ["MakeUnavailable"];
    }

    if (prefix.IsPublished) {
        return ["MakeAvailable", "Unpublish"];
    }

    return ["Publish"];
}

// Customers may have allowed a published prefix through their firewalls
export function canDelete(prefix: RegionPublicIpPrefixResource): boolean {
    return !prefix.IsPublished;
}
